import { Mission } from '@/features/missions/types/mission.type'
import LinkedMissionCard from './LinkedMissionCard'
import Accordion from '@/common/components/Accordion'

interface LinkedMissionsProps {
  missions: Mission[]
}

export default function LinkedMissions({
  missions
}: LinkedMissionsProps) {
  return (
    <Accordion
      name="linked_missions"
      head="Missões vinculadas"
      body={
        <div className='grid grid-cols-2 gap-2 w-full overflow-auto'>
          {missions.map((mission) => (
            <LinkedMissionCard mission={mission} key={mission.id} />
          ))}
        </div>
      }
    />
  )
}
